 <script>
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import format from 'date-fns/format'
  
  import store from '@/store'
  import { bgColor } from '@/helpers/bgColor'
  import { countBgColor } from '@/helpers/countBgColor'

  import EventBus from '@/event-bus'

  @Component({
    props: {
      userRole: String,
      teacherInfo: [Array, Object],
      motpOption: String,
      average: Number,
      count: Number,
      viewByAvgOrCount: String,
      commentsList: Array,
      component: String,
      componentDescription: String,
      dashboardType: String
    },
    computed: {
      sortComments(){
        const sortedObjects = this.commentsList.sort(function(a, b){
          return a.MOTPID - b.MOTPID
        })
        return sortedObjects
      },
      compName(){
        if (this.componentDescription) {
          return this.comments
          ? this.componentDescription.replace(" (obs)", "")
                                      .replace(" (p&p)", "")
          : null
        }
      },
      displayAverageOrCount(){
        if (this.viewByAvgOrCount === 'average') {
          return this.average ? this.average.toFixed(2) : 'N/A'
        } else {
          return this.count !== null ? this.count : 0
        }
      },
      styleAverageOrCount(){
        if (this.viewByAvgOrCount === 'average') {
          return bgColor(this.average)
        } else {
          return countBgColor(this.count)
        }
      }
    }
  })

  export default class ComponentAverage extends Vue {

    format = format
    comments = null
    dialogVisible = false
    
    userType = this.userRole
    location = store.getters['admin/getSelectedSchool'] 
      ? store.getters['admin/getSelectedSchool'] : store.getters.getDBN
    userName = store.getters.getUserName

    mounted(){
      this.getComments()
    }

    getComments(){
      if (this.dashboardType === 'teacher' || this.dashboardType === 'adminTeacher'){
        this.comments = this.commentsList[0]
      } 
    }
    
    async sendDataForModalRendering () {
      
      EventBus.$emit('loading')

      const dispatchFetchTeacherComments = await store.dispatch('admin/fetchTeacherComments', this.teacherInfo)

      EventBus.$emit('teacherComments', {
        teacher: dispatchFetchTeacherComments,
        component: this.component,
        description: this.componentDescription
      })

       this.$ga.event({
        eventCategory: 'View Component Comments',
        eventAction: this.component,
        eventLabel: this.userRole
      })

    }

    openModal(component) {
      
      this.dialogVisible = true

      this.$ga.event({
        eventCategory: 'View Component Comments',
        eventAction: component,
        eventLabel: this.userRole
      })
      
    }

  }
</script>

<template>

  <div class="component-average">

    <transition name="fade" mode="out-in">
      <el-button v-if="userRole !== 'Teacher' && this.dashboardType !== 'adminTeacher'"
        class="component-value"
        :key="viewByAvgOrCount === 'average' ? 1 : 2"    
        type="text" 
        @click="sendDataForModalRendering()">      
        <div class="value" 
          :style="{ backgroundColor: styleAverageOrCount }">
          <p>{{ displayAverageOrCount }}</p>
        </div>
      </el-button>
    </transition>

    <el-button v-if="userRole === 'Teacher' || this.dashboardType === 'adminTeacher'"
      class="component-value"  
      type="text" 
      @click="openModal(compName)">
      <div class="value" 
        :style="{ backgroundColor: styleAverageOrCount }">
        <p>{{motpOption ? displayAverageOrCount : 'N/A' }}</p>
      </div>
    </el-button>

    <el-dialog v-if="comments"
      :visible.sync="dialogVisible"
      width="35%">

      <div class="header">
        <h2 v-if="userRole !== 'Teacher'">
          {{teacherInfo[0].FirstName}} {{teacherInfo[0].LastName}}
        </h2>
        <h3 v-if="compName">{{compName}}</h3>
        <p v-else>No additional data is available pertaining to this component in this year.</p>
      </div>

      <div class="comments">

        <div v-for="obj in sortComments" :key="obj.id">

          <div class="flex">
            <div>
              <p>DATE</p>
              <p>CLASS</p>
              <p>OBSERVER</p>
            </div>
            <div>
              <p>{{format(obj.Date, "MMMM DD, YYYY")}}</p>
              <p>{{obj.Class}}</p>
              <p>{{obj.Observer}}</p>
            </div>
          </div>

          <div class="flex comment">
            <p>{{obj.ComponentRationale}}</p>
            <p class="rating">{{obj.Rating.toFixed(2)}}</p>
          </div>

        </div>

      </div>

    </el-dialog>

    <el-dialog v-else 
      :visible.sync="dialogVisible">
      <p class="no-comments">No comments were submitted for this component.</p>
    </el-dialog>
    
  </div>

</template>

<style lang="scss" scoped>
  .component-average {
    .el-button--text {
      color: #000;
    }
    .value {
      width: 74px;
      height: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      color: #4a4a4a;
      p {
        font-size: 16px;
      }
    }
    .flex {
      &.comment {
        margin: 15px auto;
      }
      p {
        margin: 0;
      }
    }
    .rating {
      font-size: 24px;
    }
    .no-comments {
      text-align: center;
      padding: 24px 0;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>